import styled from 'styled-components';
import { TextFieldLogin as Input } from '.';

export const TextFieldLogin = styled(Input)`
  width: 100%;
  height: 56px;
  margin-bottom: 19px;
`;